import {Group, Tooltip} from '@mantine/core';
import {IconInfoCircle} from '@tabler/icons-react';
import type {FC} from 'react';

/**
 * Info-circle icon that reveals `text` in a tooltip on hover.
 * @registry Hoverable info-circle icon with a tooltip.
 *
 * Ported from `library/elements/HelpTooltip`. Prop surface kept identical.
 */
export interface HelpTooltipProps {
  text: string;
  size?: number;
}

export const HelpTooltip: FC<HelpTooltipProps> = ({text, size = 12}) => {
  return (
    <Tooltip label={text}>
      <Group>
        <IconInfoCircle size={size} />
      </Group>
    </Tooltip>
  );
};
